import { CompanyDetailAfterMatch as CompanyDetailAfterMatchPage } from 'ui/components/agent/patterns/CompanyDetailAfterMatch/CompanyDetailAfterMatch';

/**
 * 売り手企業詳細（マッチング後のため詳細情報を取得可能）
 */
export const CompanyDetailAfterMatch: React.FC = () => {
    return <CompanyDetailAfterMatchPage />;
};
